import { useState } from 'react';
import './Header.scss';
import downloadIcon from '../../src/assets/images/download.svg';
import mailIcon from '../../src/assets/images/email.svg';
import EmailBlade from '../InvoiceDetail/EmailBlade';
import { useNavigate } from 'react-router-dom';

interface PropData {
    data?: any;
    code?: string;
    invoice?: string;
    isSignHeader?: boolean;
    isCheckList?: boolean;
    title?: string
    receipt?: boolean;
    onTermsClick?: any;
     onDownloadClick?: any;
}

const Header = (props: PropData) => {
    const [emailModal, setShowEmailModal] = useState(false)
    const navigate = useNavigate();

    const closeEmailBlade = () => {
        setShowEmailModal(false)
    }
    return (
        <>
            {
                props.isSignHeader === true ?
                    <div className='header'>
                        <div className='p-4'>
                            <div className='invoice-title'>Sign Invoice</div>
                        </div>
                    </div>
                    :
                    props.isCheckList == true ?
                        <div className='header'>
                            <div className='p-4'>
                                <div className='invoice-title'>{props.title}</div>
                            </div>
                        </div>
                        :
                        <>
                            <EmailBlade
                                isShow={emailModal}
                                isClose={closeEmailBlade}
                                data={props?.data}
                                code={props.code ? props.code : ''}
                                invoiceNum={props.invoice ? props.invoice : ''}
                                invoicePdfURL={props?.data?.callInfo?.invoicePDFUrl}
                            />
                            <div className='header'>
                                <div className='d-flex justify-content-between p-4'>
                                    <div className='invoice-title'>Invoice</div>
                                    {
                                        props?.data?.callInfo &&
                                        <div className={props.receipt ? 'd-none' : ''}>
                                            <span className='termsConditionText' onClick={() => props.onTermsClick()}>Terms & Conditions</span>
                                            <img src={mailIcon} onClick={() => setShowEmailModal(true)} className='cursor-pointer' />
                                            <img src={downloadIcon} className='ms-2 cursor-pointer' onClick={() => props?.data?.callInfo?.invoicePDFUrl && window.open(props.data.callInfo.invoicePDFUrl)} />
                                            <img style={{ display: 'none' }} src={downloadIcon} className='ms-2 cursor-pointer' onClick={() => props.onDownloadClick()} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </>
            }
        </>
    )
}

export default Header;